<style lang="scss">
img {
  width: 100%;
  height: auto;
}
.swiper-component-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  height: 100%;
  // background-color: white;
}
.swiper-button-next,
.swiper-button-prev {
  width: 106px;
  height: 106px;
  background-color: transparent;
  border-radius: 100%;
  background-image: url(../assets/button.svg);
  background-size: contain;
  background-position: center;
  bottom: 10px;
  margin-top: 0;
  top: auto;
  position: absolute;
  &:after {
    display: none;
  }
  transition: all 0.2s ease-out;
  &:hover {
    transform: scale(1.1);
  }
}
.swiper-button-disabled {
  opacity: 0 !important;
  transform: scale(0.5);
}
.swiper-button-prev {
  transform: scaleX(-1);
  &:hover {
    transform: scaleX(-1) scale(1.1);
  }
}
.scover {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #fff, $alpha: 0.5);
  z-index: 9;
}
</style>

<template>
  <div class="swiper">
    <div class="swiper-wrapper">
      <slot />
    </div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
    <!-- <div class="scover"></div> -->
  </div>
</template>

<script>
import Swiper from "swiper";
import "../assets/swiper.css";

export default {
  data() {
    return {
      swiperInstance: false,
      reInit: false
    };
  },
  props: {
    bookName: {
      type: String,
      default: ""
    },
    options: {
      type: Object,
      default() {
        return {
          // allowTouchMove: false,
          spaceBetween: 100,
          keyboard: true,
          threshold: 100,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          on: {
            slideNextTransitionStart: () => {
              if (this.swiperInstance) {
                this.$emit("slide-change", this.swiperInstance.realIndex);
                console.log("next: " + this.swiperInstance.realIndex);
              }
              if (window.cf_log_page_view) {
                window.cf_log_page_view(this.swiperInstance.realIndex + 1);
              }
            },
            slidePrevTransitionStart: () => {
              if (this.swiperInstance) {
                this.$emit("slide-change", this.swiperInstance.realIndex);
                console.log("prev: " + this.swiperInstance.realIndex);
              }
            },
            reachEnd: () => {
              // eslint-disable-next-line no-undef
              fbq("track", `FastHeroes_Ebook${this.bookName}End`);
              console.log("reach end");
              console.log(
                window.cf_unlock_next_book,
                window.cf_mark_book_as_completed
              );
              if (
                window.cf_unlock_next_book &&
                window.cf_mark_book_as_completed
              ) {
                window.cf_unlock_next_book();
                window.cf_mark_book_as_completed();
              }
            }
          }
        };
      }
    }
  },
  methods: {
    init(initialSlide = 0) {
      let options = this.options;
      options.initialSlide = initialSlide;
      this.swiperInstance = new Swiper(this.$el, options);
    }
  },
  mounted() {
    this.init();
  }
};
</script>
